"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _PulseUtil = _interopRequireDefault(require("../util/PulseUtil"));

var Constants = _interopRequireWildcard(require("../constants/Constants"));

var types = _interopRequireWildcard(require("../store/actions/actionTypes"));

var NotificationsSelectors = _interopRequireWildcard(require("../store/reducers/NotificationReducer"));

var _PulseApiHelper = _interopRequireDefault(require("./PulseApiHelper"));

var TimelineService =
/*#__PURE__*/
function () {
  function TimelineService() {
    (0, _classCallCheck2.default)(this, TimelineService);
  }

  (0, _createClass2.default)(TimelineService, [{
    key: "fetchTimeline",
    value: function () {
      var _fetchTimeline = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(store) {
        var params,
            timelineData,
            pulseApiHelper,
            url,
            activeIMSOrg,
            locale,
            data,
            response,
            notifications,
            parsedNotifications,
            previousPageUrl,
            previousPageTimestamp,
            notificationsById,
            serverTimestamp,
            _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                timelineData = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                pulseApiHelper = new _PulseApiHelper.default();
                url = new URL("".concat(pulseApiHelper.getHostUrl(), "/ans/v2/notifications/timeline"));
                params['config_version'] = 0;
                activeIMSOrg = NotificationsSelectors.getActiveIMSOrg(store.getState());
                locale = _PulseUtil.default.getNotificationsLocaleMapper(NotificationsSelectors.getLocale(store.getState()));
                params[Constants.IMS_ORG_PARAM] = activeIMSOrg;
                params[Constants.LOCALE] = locale;
                url.search = new URLSearchParams(params);

                if (!(!timelineData || typeof timelineData === 'undefined' || Object.keys(timelineData).length === 0 && timelineData.constructor === Object)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 13;
                return fetch(url, {
                  method: 'GET',
                  headers: pulseApiHelper.getDefaultHeaders()
                });

              case 13:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 16;
                  break;
                }

                throw new Error("TimelineService fetchTimeline failed, HTTP status ".concat(response.status));

              case 16:
                _context.next = 18;
                return response.json();

              case 18:
                data = _context.sent;
                _context.next = 22;
                break;

              case 21:
                data = timelineData;

              case 22:
                notifications = (0, _get2.default)(data, 'notifications', []);
                parsedNotifications = [];
                notifications.forEach(function (notification) {
                  var parsedNotification = pulseApiHelper.createPulseMessageObject(notification);

                  if (parsedNotification !== null) {
                    parsedNotifications.push(parsedNotification);
                  }
                });
                previousPageUrl = (0, _get2.default)(data, 'paging').previous;
                previousPageTimestamp = params.to;

                if (previousPageUrl) {
                  previousPageTimestamp = _PulseUtil.default.getQueryParamFromUrl(previousPageUrl, 'to');
                } //transform the array into an object with id as the key


                notificationsById = (0, _keyBy2.default)(parsedNotifications, function (notification) {
                  return notification.id;
                });
                _context.next = 31;
                return store.dispatch({
                  type: types.NOTIFICATIONS_FETCHED,
                  payload: {
                    notificationsById: notificationsById,
                    previousPageTimestamp: previousPageTimestamp
                  }
                });

              case 31:
                serverTimestamp = (0, _get2.default)(data, 'server-timestamp');
                _context.next = 34;
                return store.dispatch({
                  type: types.LATEST_SERVER_TIMESTAMP_FETCHED,
                  serverTimestamp: serverTimestamp
                });

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetchTimeline(_x) {
        return _fetchTimeline.apply(this, arguments);
      }

      return fetchTimeline;
    }()
  }]);
  return TimelineService;
}();

exports.default = TimelineService;